import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { Features, UserRoleViewModel } from '../../../business-entities/user-role-view-model';
import { RolesRightsService } from '../../../business-services/roles-rights.service';
import * as fromEnums from './../../../../../../Autofacets-Core/src/app/utils/enums';
import { RoleDetailsViewModel } from './../../../business-entities/role-details-view-model';
import * as Enums from '../../../../../../Autofacets-Core/src/app/utils/enums';

@Component({
  selector: 'app-edit-roles-rights',
  templateUrl: 'edit-roles-rights.component.html',
  styleUrls: []
})
export class EditRolesRightsComponent implements OnInit {

  role: UserRoleViewModel;
  roleDetails: RoleDetailsViewModel;
  features: Features[] = [];
  IsRentalCarActive:boolean;

  constructor(
    private rolesRightsService: RolesRightsService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private currentLanguageService: CurrentLanguage,
    private userService: UserDataService,
    private router: Router,
    private secureService: SecureStorage,
    private activeModal : NgbActiveModal,
    private translate: TranslateService,
  ) { }

  ngOnInit() {
    this.role = this.rolesRightsService.selectedRole;
    this.getRoleDetails();
    this.currentLanguageService.featureList.subscribe(res => {
      this.features = res;
      if (this.features && this.features.length > 0) {
        this.IsRentalCarActive = this.features.find(x => x.featureCode === Enums.FeatureCode.RenatlCar)?.isActive;
      }
    });
  }

  async getRoleDetails() {
    this.spinner.show();
    this.roleDetails = await this.rolesRightsService.getRoleDetails(this.role.id);
    this.spinner.hide();
  }

  onCanViewChange(value: boolean, index: number) {
    if (!value) {
      this.roleDetails.roleDetailsList[index].canAdd = false;
      this.roleDetails.roleDetailsList[index].canEdit = false;
      this.roleDetails.roleDetailsList[index].canDelete = false;
    }
  }

  onRightsChange(value: boolean, index: number){
    if (this.roleDetails.roleDetailsList[index].canAdd || this.roleDetails.roleDetailsList[index].canEdit || this.roleDetails.roleDetailsList[index].canDelete) {
      this.roleDetails.roleDetailsList[index].canView = true;
    }
  }

  checkIfDisabled(_index: number) {
     // This is intentional

  }


  async onSaveChanges() {
    this.updateRoleDetails();
    let CustomerRole=this.roleDetails.roleDetailsList.filter(x=>x.moduleId===fromEnums.ModuleNames.Customer)[0];
    let WidgetAppointmentRole=this.roleDetails.roleDetailsList.filter(x=>x.moduleId===fromEnums.ModuleNames.WidgetAppointment)[0];
    if((WidgetAppointmentRole?.canAdd || WidgetAppointmentRole?.canEdit || WidgetAppointmentRole?.canView) && !(CustomerRole?.canAdd && CustomerRole?.canEdit && CustomerRole?.canView) )
    {
      let ErrorMessage = this.translate.instant("lblCustomerScreenRoleRightRequireWithWAR");
      this.toastr.error(ErrorMessage);
      return;
    }
    this.rolesRightsService.saveRoleRights(this.roleDetails).then((response) => {
      const responseObject = response.responseObject;
      if (responseObject.errorCount > 0) {
        const errorObject = responseObject.result;
        if (errorObject.errorCode === fromEnums.ErrorCodes.RolesNotUpdated)
          this.toastr.error(fromEnums.ToastrMessages.RolesNotUpdatedErrorMessage);
      }
      const isUpdated = responseObject.result as boolean;
      if (isUpdated) {
        // Success
        this.toastr.success(fromEnums.ToastrMessages.RolesNotUpdated);
        this.updateUserRoleDetails();
      }
    });
  }

  updateRoleDetails() {
    this.roleDetails.roleDetailsList.forEach(x => {
      if (x.moduleId === fromEnums.ModuleNames.RolesRights) {
        const value = (this.role.id === fromEnums.UserRoles.SuperAdmin || this.role.id === fromEnums.UserRoles.SuperUser);
        x.canAdd = value;
        x.canEdit = value;
        x.canDelete = value;
        x.canView = value;
      }
      return x;
    });
  }

  async updateUserRoleDetails() {
    this.spinner.show();
    this.secureService.removeKey(fromEnums.SecureStorageKey.GetUserDetails);
    await this.userService.GetUserDetails();
    this.spinner.hide();
    this.router.navigate(['/roles-rights']);
  }
  OnClose(){
    this.activeModal.close({success:false})
  }
}
